export const scrollRestoreConfig = {
  debug: false, // Set to true to enable console logging
}
